
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-mapkit.cjs.production.min.js')
} else {
  module.exports = require('./react-mapkit.cjs.development.js')
}
